import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=36c7ded2&scoped=true&"
var script = {}
import style0 from "./TopHeader.vue?vue&type=style&index=0&id=36c7ded2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c7ded2",
  null
  
)

export default component.exports